import {
  BOOT_PLAYBACK_COVER_IDLE_MAX_MS,
  BOOT_PLAYBACK_COVER_MAX_MS
} from '@/constants'

/**
 * Long cover (hybrid first-frame) only when the player is waiting on real content.
 * Empty playlist / weekly-availability off → short fallback so splash is not 30s of black.
 */
export function resolveBootPlaybackCoverMaxMs(input: {
  weeklyAvailabilityPlaybackSuppressed: boolean
  queueEmpty: boolean
}): number {
  if (input.weeklyAvailabilityPlaybackSuppressed || input.queueEmpty) {
    return BOOT_PLAYBACK_COVER_IDLE_MAX_MS
  }
  return BOOT_PLAYBACK_COVER_MAX_MS
}
